import * as metaStateUtils from '../../../../store/util/metaStateUtils';


export default (state, userConfigState, isLoading) => {

    userConfigState = isLoading
        ? metaStateUtils.setIsLoading(userConfigState)
        : metaStateUtils.setIsLoaded(userConfigState);
    state.user = userConfigState;

    return state;
};
